import React__default from 'react';
import { toast } from '@grandvisionhq/common';
import { useDeliveryIntervalOptions, DeliveryIntervalSelect } from '@grandvisionhq/fun-products';
import { useSolutionsEcommContext } from '../../context/SolutionsEcommContext.js';
import { useProductDetailContext } from '../../../Context/ProductDetailContext.js';

const SolutionsDeliveryIntervalSelect = ({ className  })=>{
    const { actions , state  } = useSolutionsEcommContext();
    const { deliveryIntervalOptions: defaultDeliveryIntervals  } = useProductDetailContext();
    const { deliveryInterval: deliveryInterval1  } = state.configurations.subscriptionPurchaseConfigurations;
    const { deliveryIntervalOptions , selectedInterval  } = useDeliveryIntervalOptions({
        deliveryInterval: deliveryInterval1,
        deliveryIntervalOptions: defaultDeliveryIntervals
    });
    const { deliveryInterval: { showError  } , invalidSubmissionsCount ,  } = state.configurator;
    React__default.useEffect(()=>{
        if (showError) {
            toast.failed('products.deliveryInterval.error');
        }
    }, [
        showError,
        invalidSubmissionsCount
    ]);
    const handleIntervalSelection = React__default.useCallback((deliveryInterval)=>actions.updateDeliveryInterval(deliveryInterval)
    , [
        actions
    ]);
    if (!deliveryIntervalOptions) {
        console.error('DeliveryIntervalSelect: No delivery interval options have been set');
        return null;
    }
    return /*#__PURE__*/ React__default.createElement(DeliveryIntervalSelect, {
        className: className,
        hasError: showError,
        selectedInterval: selectedInterval,
        deliveryIntervalOptions: deliveryIntervalOptions,
        onIntervalSelection: handleIntervalSelection
    });
};

export { SolutionsDeliveryIntervalSelect };
//# sourceMappingURL=SolutionsDeliveryIntervalSelect.js.map
